import clsx from 'clsx';

interface SoldInDaysComparisionLineItemProps {
  value: number | string;
  comparisionResult: number;
}

export const SoldInDaysComparisionLineItem: React.FC<
  SoldInDaysComparisionLineItemProps
> = (props) => {
  return (
    <div className="relative">
      <div
        className={clsx('absolute inset-0 -z-10 flex flex-row p-1')}
        style={{
          width: '100%',
        }}
      >
        {new Array(props.comparisionResult || 0).fill(0).map((_, i) => (
          <div
            key={i}
            className="h-full bg-red-200"
            style={{ width: 1, marginRight: 1 }}
          ></div>
        ))}
      </div>
      <div className="px-2 py-2 text-center">{props.value}</div>
    </div>
  );
};
